import { Directive, ElementRef, Injector, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudDataSource, CrudListComponent, FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { AMMUNITION_STOCK_TYPE, AmmunitionStock, AssetsUser, BUSINESS_UNIT_METADATA, BUSINESS_UNIT_TYPE, BusinessUnit, COST_CENTRE_METADATA, COST_CENTRE_TYPE, CostCentre } from 'assets-model';
import { AmmunitionStockDataSource, AmmunitionStockService, BusinessUnitService, CostCentreService } from 'assets-service';


@Directive()
export abstract class AmmunitionStockSearchComponentBase extends CrudListComponent<AmmunitionStock, number> {
  protected systemConfig: any;

  displayedColumns: string[] = [ 'ammunitionStockId', 'businessUnit.buId', 'costCentre.ccId', 'calibre', 'closed', 'createdBy', 'createdDate', 'currentStockAmount', 'hasStocktake', 'lockVersion', 'make', 'updatedBy', 'updatedDate', 'weight', 'actions'];

  public searchForm: FormGroup;

  ammunitionStockIdFilter: number;
  @ViewChild('ammunitionStockIdFilterInput') ammunitionStockIdFilterInput: ElementRef;

  businessUnitFilter: BusinessUnit;
  businessUnitSelectionList: BusinessUnit[];
  @ViewChild('businessUnitFilterInput') businessUnitFilterInput: MatSelect;

  costCentreFilter: CostCentre;
  costCentreSelectionList: CostCentre[];
  @ViewChild('costCentreFilterInput') costCentreFilterInput: MatSelect;

  calibreFilter: string;
  @ViewChild('calibreFilterInput') calibreFilterInput: ElementRef;

  closedFilter: boolean;
  @ViewChild('closedFilterInput') closedFilterInput: MatSelect;

  createdByFilter: string;
  @ViewChild('createdByFilterInput') createdByFilterInput: ElementRef;

  createdDateFilter: Date;
  @ViewChild('createdDateFilterInput') createdDateFilterInput: ElementRef;
  createdDateLessThanFilter: Date;
  @ViewChild('createdDateLessThanFilterInput') createdDateLessThanFilterInput: ElementRef;
  createdDateLessThanOrEqualToFilter: Date;
  @ViewChild('createdDateLessThanOrEqualToFilterInput') createdDateLessThanOrEqualToFilterInput: ElementRef;
  createdDateGreaterThanFilter: Date;
  @ViewChild('createdDateGreaterThanFilterInput') createdDateGreaterThanFilterInput: ElementRef;
  createdDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('createdDateGreaterThanOrEqualToFilterInput') createdDateGreaterThanOrEqualToFilterInput: ElementRef;

  makeFilter: string;
  @ViewChild('makeFilterInput') makeFilterInput: ElementRef;

  updatedByFilter: string;
  @ViewChild('updatedByFilterInput') updatedByFilterInput: ElementRef;

  updatedDateFilter: Date;
  @ViewChild('updatedDateFilterInput') updatedDateFilterInput: ElementRef;
  updatedDateLessThanFilter: Date;
  @ViewChild('updatedDateLessThanFilterInput') updatedDateLessThanFilterInput: ElementRef;
  updatedDateLessThanOrEqualToFilter: Date;
  @ViewChild('updatedDateLessThanOrEqualToFilterInput') updatedDateLessThanOrEqualToFilterInput: ElementRef;
  updatedDateGreaterThanFilter: Date;
  @ViewChild('updatedDateGreaterThanFilterInput') updatedDateGreaterThanFilterInput: ElementRef;
  updatedDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('updatedDateGreaterThanOrEqualToFilterInput') updatedDateGreaterThanOrEqualToFilterInput: ElementRef;

  weightFilter: string;
  @ViewChild('weightFilterInput') weightFilterInput: ElementRef;


  get eAssetsUser(): AssetsUser {
    return AssetsUser.assignAs(this.userDetails);
  }

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected ammunitionStockService: AmmunitionStockService,
    protected businessUnitService: BusinessUnitService,
    protected costCentreService: CostCentreService,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(AMMUNITION_STOCK_TYPE, route, router, userStorage, dialog, ammunitionStockService, injector);

    this.searchForm = this.fb.group({
      ammunitionStockId: [null],
      businessUnit: [null],
      costCentre: [null],
      calibre: [null],
      closed: [null],
      createdBy: [null],
      createdDateLessThan: [null],
      createdDateLessThanOrEqualTo: [null],
      createdDateGreaterThan: [null],
      createdDateGreaterThanOrEqualTo: [null],
      createdDate: [null],
      make: [null],
      updatedBy: [null],
      updatedDateLessThan: [null],
      updatedDateLessThanOrEqualTo: [null],
      updatedDateGreaterThan: [null],
      updatedDateGreaterThanOrEqualTo: [null],
      updatedDate: [null],
      weight: [null]
    });
  }

  createDataSource(): CrudDataSource<AmmunitionStock> {
    return new AmmunitionStockDataSource(this.ammunitionStockService);
  }

  createServiceArguments(): any {
    return {
      ammunitionStockId: this.ammunitionStockIdFilter,
      buId: this.businessUnitFilter && this.businessUnitFilter.buId,
      ccId: this.costCentreFilter && this.costCentreFilter.ccId,
      calibre: this.calibreFilter,
      closed: this.closedFilter,
      createdBy: this.createdByFilter,
      createdDateLessThan: this.createdDateLessThanFilter,
      createdDateLessThanOrEqualTo: this.createdDateLessThanOrEqualToFilter,
      createdDateGreaterThan: this.createdDateGreaterThanFilter,
      createdDateGreaterThanOrEqualTo: this.createdDateGreaterThanOrEqualToFilter,
      createdDate: this.createdDateFilter,
      make: this.makeFilter,
      updatedBy: this.updatedByFilter,
      updatedDateLessThan: this.updatedDateLessThanFilter,
      updatedDateLessThanOrEqualTo: this.updatedDateLessThanOrEqualToFilter,
      updatedDateGreaterThan: this.updatedDateGreaterThanFilter,
      updatedDateGreaterThanOrEqualTo: this.updatedDateGreaterThanOrEqualToFilter,
      updatedDate: this.updatedDateFilter,
      weight: this.weightFilter
    };
  }
  
  clearFiltersBeforeLoadPage() {
    this.restoreFormFromParams(this.searchForm);
  }
  
  clearFilterVariables() {
    this.ammunitionStockIdFilter = null;
    this.businessUnitFilter = null;
    this.costCentreFilter = null;
    this.calibreFilter = null;
    this.closedFilter = null;
    this.createdByFilter = null;
    this.createdDateLessThanFilter = null;
    this.createdDateLessThanOrEqualToFilter = null;
    this.createdDateGreaterThanFilter = null;
    this.createdDateGreaterThanOrEqualToFilter = null;
    this.createdDateFilter = null;
    this.makeFilter = null;
    this.updatedByFilter = null;
    this.updatedDateLessThanFilter = null;
    this.updatedDateLessThanOrEqualToFilter = null;
    this.updatedDateGreaterThanFilter = null;
    this.updatedDateGreaterThanOrEqualToFilter = null;
    this.updatedDateFilter = null;
    this.weightFilter = null;
  }
  
  clearFilters() {
    this.clearFilterVariables();
    this.clearFiltersBeforeLoadPage();
    this.loadPage();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.addSearchOnChangedInputEventListener(this.ammunitionStockIdFilterInput);
    this.addSearchOnChangedSelectEventListener(this.businessUnitFilterInput);
    this.addSearchOnChangedSelectEventListener(this.costCentreFilterInput);
    this.addSearchOnChangedInputEventListener(this.calibreFilterInput);
    this.addSearchOnChangedSelectEventListener(this.closedFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdByFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateFilterInput);
    this.addSearchOnChangedInputEventListener(this.makeFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedByFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateFilterInput);
    this.addSearchOnChangedInputEventListener(this.weightFilterInput);
    this.formStorage.rememberFormChanges(this.searchForm);
  }

  ngOnInit() {
    super.ngOnInit();
  }
  
  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
  }

  protected initExportOptions(config: any): any {
    config = config || {};
    return config;
  }

  protected initConfig(config: any) {
    super.initConfig(config);
    this.systemConfig = this.initExportOptions(config);
  }
  
  protected transformAllPropertiesToModelSetters(): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    const self = this;
    return {
      ammunitionStockId: (value: number) => self.ammunitionStockIdFilter = value,
      businessUnit: (value: BusinessUnit) => { self.businessUnitFilter = value; this.businessUnitChanged(value, false); },
      costCentre: (value: CostCentre) => { self.costCentreFilter = value; this.costCentreChanged(value, false); },
      calibre: (value: string) => self.calibreFilter = value,
      closed: (value: boolean) => self.closedFilter = value,
      createdBy: (value: string) => self.createdByFilter = value,
      createdDateLessThan: (value: Date) => self.createdDateLessThanFilter = value,
      createdDateLessThanOrEqualTo: (value: Date) => self.createdDateLessThanOrEqualToFilter = value,
      createdDateGreaterThan: (value: Date) => self.createdDateGreaterThanFilter = value,
      createdDateGreaterThanOrEqualTo: (value: Date) => self.createdDateGreaterThanOrEqualToFilter = value,
      createdDate: (value: Date) => self.createdDateFilter = value,
      make: (value: string) => self.makeFilter = value,
      updatedBy: (value: string) => self.updatedByFilter = value,
      updatedDateLessThan: (value: Date) => self.updatedDateLessThanFilter = value,
      updatedDateLessThanOrEqualTo: (value: Date) => self.updatedDateLessThanOrEqualToFilter = value,
      updatedDateGreaterThan: (value: Date) => self.updatedDateGreaterThanFilter = value,
      updatedDateGreaterThanOrEqualTo: (value: Date) => self.updatedDateGreaterThanOrEqualToFilter = value,
      updatedDate: (value: Date) => self.updatedDateFilter = value,
      weight: (value: string) => self.weightFilter = value
    }
  }
  
  restoreFormChanges() {
    const self = this;

    // IMPORTANT that the restoreFormChanges call occurs before the initial search - typically best done in onInitAsyncComplete
    // Whereever a form control binds with [ngModel] to a reactive form, ngModel takes precedence,
    // and needs it's own setter function to set the scope attribute bound
    this.formStorage.restoreFormChanges(this.searchForm, this.transformAllPropertiesToModelSetters());
  }

  ammunitionStockIdChanging(value: number, unsetDependents: boolean = true) {}
  
  ammunitionStockIdChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  businessUnitLoadSelectionList() {
    this.businessUnitService.findAll().subscribe(
      data => {
        this.businessUnitSelectionList = data.items;
      }
    );
  }
  
  businessUnitDisplay(item: BusinessUnit) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return BUSINESS_UNIT_TYPE.description(item);
  }
  
  businessUnitChanging(value: BusinessUnit, unsetDependents: boolean = true) {}
  
  businessUnitChanged(value: BusinessUnit, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }
  
  businessUnitCompare(a: any, b: any) {
    return BUSINESS_UNIT_METADATA.equals(a, b);
  }
  
  

  costCentreLoadSelectionList() {
    this.costCentreService.findAll().subscribe(
      data => {
        this.costCentreSelectionList = data.items;
      }
    );
  }
  
  costCentreDisplay(item: CostCentre) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return COST_CENTRE_TYPE.description(item);
  }
  
  costCentreChanging(value: CostCentre, unsetDependents: boolean = true) {}
  
  costCentreChanged(value: CostCentre, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }
  
  costCentreCompare(a: any, b: any) {
    return COST_CENTRE_METADATA.equals(a, b);
  }
  
  

  calibreChanging(value: string, unsetDependents: boolean = true) {}
  
  calibreChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  closedChanging(value: boolean, unsetDependents: boolean = true) {}
  
  closedChanged(value: boolean, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdByChanging(value: string, unsetDependents: boolean = true) {}
  
  createdByChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  makeChanging(value: string, unsetDependents: boolean = true) {}
  
  makeChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedByChanging(value: string, unsetDependents: boolean = true) {}
  
  updatedByChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  weightChanging(value: string, unsetDependents: boolean = true) {}
  
  weightChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  disabledTooltip(element) {
    if (!element) {
      return true;
    }
    return element.valid || !element.touched;
  }

  get ammunitionStockId() {
    return this.searchForm && this.searchForm.get('ammunitionStockId');
  }

  get businessUnit() {
    return this.searchForm && this.searchForm.get('businessUnit');
  }

  get costCentre() {
    return this.searchForm && this.searchForm.get('costCentre');
  }

  get calibre() {
    return this.searchForm && this.searchForm.get('calibre');
  }

  get closed() {
    return this.searchForm && this.searchForm.get('closed');
  }

  get createdBy() {
    return this.searchForm && this.searchForm.get('createdBy');
  }

  get createdDate() {
    return this.searchForm && this.searchForm.get('createdDate');
  }

  get createdDateLessThan() {
    return this.searchForm && this.searchForm.get('createdDateLessThan');
  }
  
  get createdDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('createdDateLessThanOrEqualTo');
  }
  
  get createdDateGreaterThan() {
    return this.searchForm && this.searchForm.get('createdDateGreaterThan');
  }
  
  get createdDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('createdDateGreaterThanOrEqualTo');
  }

  get make() {
    return this.searchForm && this.searchForm.get('make');
  }

  get updatedBy() {
    return this.searchForm && this.searchForm.get('updatedBy');
  }

  get updatedDate() {
    return this.searchForm && this.searchForm.get('updatedDate');
  }

  get updatedDateLessThan() {
    return this.searchForm && this.searchForm.get('updatedDateLessThan');
  }
  
  get updatedDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('updatedDateLessThanOrEqualTo');
  }
  
  get updatedDateGreaterThan() {
    return this.searchForm && this.searchForm.get('updatedDateGreaterThan');
  }
  
  get updatedDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('updatedDateGreaterThanOrEqualTo');
  }

  get weight() {
    return this.searchForm && this.searchForm.get('weight');
  }


}



